import { render } from "./ChatDisplay.vue?vue&type=template&id=6c01b2b8&scoped=true"
import script from "./ChatDisplay.vue?vue&type=script&lang=js"
export * from "./ChatDisplay.vue?vue&type=script&lang=js"

import "./ChatDisplay.vue?vue&type=style&index=0&id=6c01b2b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c01b2b8"]])

export default __exports__